import { render } from "./ProductListViewItem.vue?vue&type=template&id=5a8805f8"
import script from "./ProductListViewItem.vue?vue&type=script&lang=js"
export * from "./ProductListViewItem.vue?vue&type=script&lang=js"

import "./ProductListViewItem.vue?vue&type=style&index=0&id=5a8805f8&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__